import "./NNCapital.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import ProductGrid from "./sections/ProductGrid";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function NNCapitalPage() {
  return <div>
      <Header />
      <HeroSection />
      <ProductGrid />
      <ContactUs />
      <Footer />
    </div>;
}